import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { MaterializedProcess, Step } from 'modules/processes/domain'
import type { Process } from 'modules/processes/hooks/useProcesses'

import PageHeader from './PageHeader'
import Steps from './Steps'

interface Props {
  process: Process
  materializedProcess: MaterializedProcess
}

const MaterializedProcessPage = ({ process, materializedProcess }: Props) => {
  useEffect(() => {
    track(trackingEvents.processes.processInstancePageOpened, {
      category: process.category,
    })
  }, [process.category])

  return (
    <Box gap="s48">
      <PageHeader process={process} materializedProcess={materializedProcess} />

      <Box gap="s48">
        <Steps
          processId={process.id}
          steps={process.steps as Step[]} // eslint-disable-line no-type-assertion/no-type-assertion
          materializedProcessId={materializedProcess.id}
          materializedProcessStatus={materializedProcess.status}
          materializedProcessFinalizedAt={materializedProcess.finalizedAt}
          materializedSteps={materializedProcess.materializedSteps}
          materializedProcessAccessId={Number(
            materializedProcess.resourceRelationships[0]?.resourceId
          )}
        />
      </Box>
    </Box>
  )
}

export default observer(MaterializedProcessPage)
